/// <reference path="DOMAttached.js" />
/// <reference path="GamesQuiz.js" />
/// <reference path="../../../gulp/node_modules/soundmanager2/script/soundmanager2-nodebug.js" />

var ToggleFeedbackSoundInstance = null;

class ToggleFeedbackSound extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		ToggleFeedbackSoundInstance = this;
		this.button = document.getElementById(options.buttonLink);
		this.imgPlay = document.getElementById(options.playButton);
		this.imgPause = document.getElementById(options.pauseButton);
		this.turnOnTooltip = options.turnOnTooltip;
		this.turnOffTooltip = options.turnOffTooltip;
		this.url = this.button.href;
		this.button.href = '#?';
		this.safeObserve(this.button, 'click', this.onClick.bind(this));

		if (GenericSoundsInstance !== undefined && GenericSoundsInstance !== null) {
			if (GenericSoundsInstance.playFeedbackSound) {
				this.imgPlay.style.display = 'none';
				this.imgPause.style.display = 'block';
				this.button.title = this.turnOffTooltip;
			} else {
				this.imgPlay.style.display = 'block';
				this.imgPause.style.display = 'none';
				this.button.title = this.turnOnTooltip;
			}
		}
	}

	onClick(ev) {
		ev.preventDefault();

		axios(this.url, {
			method: 'get'
		}).then(() => {
			this.onSuccess();
		});
	}

	onSuccess() {
		if (GenericSoundsInstance !== undefined && GenericSoundsInstance.playFeedbackSound !== undefined) {
			GenericSoundsInstance.playFeedbackSound = !GenericSoundsInstance.playFeedbackSound;
			if (GenericSoundsInstance.playFeedbackSound) {
				this.imgPlay.style.display = 'none';
				this.imgPause.style.display = 'block';
				this.button.title = this.turnOffTooltip;
				if (window.PlayFeedbackSound != null) {
					window.PlayFeedbackSound = true;
				}
			} else {
				soundManager.stop('intro');
				soundManager.stop('theme');
				this.imgPlay.style.display = 'block';
				this.imgPause.style.display = 'none';
				this.button.title = this.turnOnTooltip;
				if (window.PlayFeedbackSound != null) {
					window.PlayFeedbackSound = false;
				}
			}
		}
	}
}
